import React from "react";

const List = (props: any) => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.5467 5.17483H0.944093C0.804617 5.17483 0.665039 5.03496 0.665039 4.8951V0.279721C0.665039 0.139861 0.804617 0 0.944093 0H5.5467C5.68618 0 5.82575 0.139861 5.82575 0.279721V1.67832C5.82575 1.81818 5.68618 1.95804 5.5467 1.95804C5.40722 1.95804 5.26782 1.81818 5.26782 1.67832V0.559443H1.36242V4.47552H5.26782V3.63637C5.26782 3.49651 5.40722 3.35664 5.5467 3.35664C5.68618 3.35664 5.82575 3.49651 5.82575 3.63637V4.75525C5.96523 5.03497 5.82565 5.17483 5.5467 5.17483Z"
        fill="#4D4D4D"
      />
      <path
        d="M21.0287 1.11895H9.03377C8.89429 1.11895 8.75488 0.979091 8.75488 0.839231C8.75488 0.69937 8.89429 0.559509 9.03377 0.559509H21.0287C21.1681 0.559509 21.3077 0.69937 21.3077 0.839231C21.3077 0.979091 21.1681 1.11895 21.0287 1.11895Z"
        fill="#4D4D4D"
      />
      <path
        d="M16.8436 3.77623H9.17244C9.03296 3.77623 8.89355 3.63637 8.89355 3.49651C8.89355 3.35665 9.03296 3.2168 9.17244 3.2168H16.8436C16.9831 3.2168 17.1227 3.35665 17.1227 3.49651C17.1227 3.63637 16.9831 3.77623 16.8436 3.77623Z"
        fill="#4D4D4D"
      />
      <path
        d="M5.5467 12.5874H0.944093C0.804617 12.5874 0.665039 12.4476 0.665039 12.3077V7.69231C0.665039 7.55245 0.804617 7.4126 0.944093 7.4126H5.5467C5.68618 7.4126 5.82575 7.55245 5.82575 7.69231V12.3077C5.96523 12.4476 5.82565 12.5874 5.5467 12.5874ZM1.36242 11.8881H5.26782V7.97203H1.36242V11.8881Z"
        fill="#4D4D4D"
      />
      <path
        d="M21.0287 8.53143H9.03377C8.89429 8.53143 8.75488 8.39157 8.75488 8.25171C8.75488 8.11185 8.89429 7.97198 9.03377 7.97198H21.0287C21.1681 7.97198 21.3077 8.11185 21.3077 8.25171C21.3077 8.39157 21.1681 8.53143 21.0287 8.53143Z"
        fill="#4D4D4D"
      />
      <path
        d="M16.8436 11.3287H9.17244C9.03296 11.3287 8.89355 11.1888 8.89355 11.0489C8.89355 10.9091 9.03296 10.7692 9.17244 10.7692H16.8436C16.9831 10.7692 17.1227 10.9091 17.1227 11.0489C17.1227 11.1888 16.9831 11.3287 16.8436 11.3287Z"
        fill="#4D4D4D"
      />
      <path
        d="M5.5467 20H0.944093C0.804617 20 0.665039 19.8601 0.665039 19.7202V15.1049C0.665039 14.965 0.804617 14.8251 0.944093 14.8251H5.5467C5.68618 14.8251 5.82575 14.965 5.82575 15.1049V19.7202C5.96523 19.8601 5.82565 20 5.5467 20ZM1.36242 19.3007H5.26782V15.3846H1.36242V19.3007Z"
        fill="#4D4D4D"
      />
      <path
        d="M21.0287 15.944H9.03377C8.89429 15.944 8.75488 15.8042 8.75488 15.6643C8.75488 15.5244 8.89429 15.3846 9.03377 15.3846H21.0287C21.1681 15.3846 21.3077 15.5244 21.3077 15.6643C21.3077 15.8042 21.1681 15.944 21.0287 15.944Z"
        fill="#4D4D4D"
      />
      <path
        d="M16.8436 18.7413H9.17244C9.03296 18.7413 8.89355 18.6014 8.89355 18.4616C8.89355 18.3217 9.03296 18.1818 9.17244 18.1818H16.8436C16.9831 18.1818 17.1227 18.3217 17.1227 18.4616C17.1227 18.6014 16.9831 18.7413 16.8436 18.7413Z"
        fill="#4D4D4D"
      />
    </svg>
  );
};

export default List;
